// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__bKKTs","spin":"Spinner_spin__O4TRG"};